import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// ✅ Patch webpack overlay + all error handlers
const patchResizeObserver = () => {
  // 1. Patch the native ResizeObserver itself
  if (typeof ResizeObserver !== "undefined") {
    const OriginalResizeObserver = ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends (
      OriginalResizeObserver
    ) {
      constructor(callback) {
        super((entries, observer) => {
          requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (e) {
              // silently ignore
            }
          });
        });
      }
    };
  }

  // 2. Block window.onerror (stops CRA overlay)
  window.onerror = (message) => {
    if (
      typeof message === "string" &&
      message.includes("ResizeObserver loop")
    ) {
      return true;
    }
  };

  // 3. Block error event (capture phase)
  window.addEventListener(
    "error",
    (e) => {
      if (e?.message?.includes("ResizeObserver loop")) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );

  // 4. Remove CRA overlay if it sneaks in
  const observer = new MutationObserver(() => {
    const overlay = document.getElementById(
      "webpack-dev-server-client-overlay",
    );
    if (overlay) overlay.remove();
    const iframeOverlay = document.querySelector('iframe[id*="webpack"]');
    if (iframeOverlay) iframeOverlay.remove();
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

patchResizeObserver();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

reportWebVitals();
